import type { Report } from '@tpct/mission-core/types/report';

type ApiDiligenceStats = {
  todo?: number;
  revised?: number;
  supervised?: number;
  anomalie?: number;
  total?: number;
};

export type UserOngoingMissionReportApiRow = {
  id: number;
  companyId: number;
  companyName: string;
  createdAt: string;
  modifiedAt: string;
  generatedAt?: string | null;
  status: Report['status'];
  lifecycle_state?: Report['lifecycle_state'];
  completionPercentage?: number;
  diligenceStats?: ApiDiligenceStats;
  files?: Report['files'];
  is_locked?: boolean;
  isLocked?: boolean;
  missionId?: number | null;
  mission?: Report['mission'];
  capabilities?: Report['capabilities'];
  display_actions?: Report['display_actions'];
  mission_missing?: boolean;
};

export const mapUserOngoingMissionReports = (
  rows: UserOngoingMissionReportApiRow[] | undefined,
): Report[] => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  return rows.map((row) => ({
    id: row.id,
    companyId: row.companyId,
    companyName: row.companyName,
    createdAt: row.createdAt,
    modifiedAt: row.modifiedAt,
    generatedAt: row.generatedAt ?? null,
    status: row.status,
    lifecycle_state: row.lifecycle_state,
    completionPercentage: row.completionPercentage ?? 0,
    diligenceStats: {
      todo: row.diligenceStats?.todo ?? 0,
      revised: row.diligenceStats?.revised ?? 0,
      supervised: row.diligenceStats?.supervised ?? 0,
      anomalie: row.diligenceStats?.anomalie ?? 0,
      total: row.diligenceStats?.total ?? 0,
    },
    files: row.files ?? {},
    isLocked: Boolean(row.isLocked ?? row.is_locked),
    missionId: row.missionId ?? null,
    mission: row.mission ?? null,
    capabilities: row.capabilities,
    display_actions: row.display_actions,
    mission_missing: row.mission_missing,
  }));
};
